export const SatisfactionEnum = {
  SATISFIED: "satisfied",
  NEUTRAL: "neutral",
  DISSATISFIED: "dissatisfied",
};
